const queryApi = async ({ method, bearer, url, data, timeout }) => {
  let result;

  let init = {
    method: method,
    headers: {
      //  'Authorization': 'Bearer ' + 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVmYTVhNjdiNmNmYWU3NTA2OGJjNDRiYyIsImlhdCI6MTYwNDg5NTMyNiwiZXhwIjoxNjEyNjcxMzI2fQ.2JxgMNiS4kKriTwhtnp5WtVaHgBjc696fVt3fkMTK64'
    },
  };

  if (!!bearer === true) init.headers.Authorization = `Bearer ${bearer}`;
  console.log("typer", typeof data);
  if (data && !!Object.keys(data).length) {
    console.log("i passed this check");
    init.body = JSON.stringify(data);
    init.headers["Content-type"] = "application/json; charset=UTF-8";
  }
  if (data instanceof FormData) {
    init.body = data;
  }

  try {
    result = await Promise.race([
      fetch(url, init),
      new Promise((res, rej) => {
        setTimeout(
          () => {
            rej(new Error("Request Timeout"));
          },
          !!timeout ? timeout : 50000,
        );
      }),
    ]);
  } catch (e) {
    //   if (e.message === 'Timeout'
    //   || e.message === 'Network request failed') {
    //   // retry
    // } else {
    //   throw e; // rethrow other unexpected errors
    // }
    return e;
  }

  try {
    const contentType = result.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      result = await result.json();
      console.log("dem don release me", result);
    } else {
      const text = await result.text();
      console.log("Non-JSON response:", text);
      return { status: "error", message: text || "Server error" };
    }
  } catch (e) {
    console.log("error", e);
    return { status: "error", message: e.message };
  }

  return result;
};

export default queryApi;
